const wcPrivateKey = '12b031af68fe46179b9d9da3743e391f'
const apiKey = 'Mjk1N2MxZWMtMzMxZC00NjZmLWFjNzMtMjg5ZWU4ZjQwOWY1'
const isDevelop = false
const standAlone = false

export { wcPrivateKey, apiKey, isDevelop, standAlone }
